import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { Component } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import FetchServerData from "../../../provider/FetchServerData";
import {
  DPTextGmailLogin_Url,
  DPTextLogin_Url,
  DPTextRmGmailLogin_Url,
  DPTextRmLogin_Url,
  DPTextTenantList_Url,
  StaticDPText_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import headerAction from "../../../redux/header/headerAction";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
import dpTextLogo from "../../../assets/img/dptextLogo.png";
import "./DPTextSignin.css";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";

export class DPTextSignin extends Component {
  debounceTimeout = null;
  constructor(props) {
    super(props);
    let pageId = "";
    if (props.state) {
      pageId = props.state.pageId;
    }

    this.state = {
      pageId: pageId,
      email: "",
      showPassword: false,
      showConfirmPassword: false,
      ischeckbox: false,
      isTenantCheckbox: false,
      tenantList: [],
      isCompany: false,
      resendOtpByEmail: false,
      resendOtpByText: false,
      sendOtpByEmail: false,
      sendOtpByText: true,
      rememberMe: false,
      isAuthenticated: false,
      error: false,
    };
  }

  componentDidMount() {
    store.dispatch(staticDataAction.setStaticData({}));
    store.dispatch(headerAction.setHeader({}));
    store.dispatch(AppUserDataAction.setUserData({}));
    store.dispatch(AppUserDataAction.setLogo({}));
    store.dispatch(ActiveMenuAction.setActiveMenu({}));
    store.dispatch(SelectedTabAction.setSelectedTab(""));
    store.dispatch(SelectedDomainAction.setSelectedDomain(""));
    store.dispatch(SelectedDomainAction.setEventState({}));
    store.dispatch(AccountSettingDataAction.setAccountSettingData({}));
    store.dispatch(CrmIntegrationAction.setCrmIntegration(""));

    // Retrieve stored credentials if "Remember Me" was checked
    const storedHeader = JSON.parse(localStorage.getItem("dptextHeader"));
    const storedGmailHeader = JSON.parse(localStorage.getItem("dptextGmailHeader"));
    // const storedUserId = localStorage.getItem("dptextUserId");
    // const storedPassword = localStorage.getItem("dptextPassword");
    const storedGoogleToken = localStorage.getItem("dptextGoogleToken");
    // const storedTenantId = localStorage.getItem("dptextSelectedOption");
    const rememberMeFlag = localStorage.getItem("dptextRememberMe");

    if (rememberMeFlag && storedGmailHeader && storedGoogleToken) {
      this.rmEmailLoginInBackend(
        storedGmailHeader
      );
      this.setState({
        rememberMe: rememberMeFlag,
        render: false,
      });
    } else {
      localStorage.removeItem("dptextHeader");
      localStorage.removeItem("dptextGmailHeader");
      localStorage.removeItem("dptextGoogleToken");
      localStorage.removeItem("dptextRememberMe");
    }

    if (rememberMeFlag && storedHeader) {
      this.setState({
        rememberMe: rememberMeFlag,
        render: false,
      });
      this.DPTextRmLoginInBackend(
        storedHeader,
      );
    } else {
      localStorage.removeItem("dptextHeader");
      localStorage.removeItem("dptextGmailHeader");
      localStorage.removeItem("dptextGoogleToken");
      localStorage.removeItem("dptextRememberMe");
    }
  }

  getTenantList(email) {
    const postObject = {
      header: {
        userid: email,
      },
    };
    FetchServerData.callPostService(DPTextTenantList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let tenantList = output.data;
          let tenantId = Utils.getArrayElement(tenantList, 0);
          if (tenantList.length > 1) {
            this.setState({
              render: true,
              email: this.state.email,
              tenantList: tenantList,
              tenantId: tenantId,
              isCompany: true,
            });
          } else {
            this.setState({
              isCompany: false,
              tenantList: tenantList,
              tenantId: tenantId,
            });
          }
        } else {
        }
      }
    );
  }

  handleEmailChange(e) {
    let val = e.target.value;
    this.setState({ email: val });

    if (val.trim() === "") {
      this.setState({ isCompany: false });
    }

    // Clear previous timer
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    // Set new debounce timer
    this.debounceTimeout = setTimeout(() => {
      const domainRegex = /\.[a-zA-Z]{2,}$/;
      if (domainRegex.test(val)) {
        this.getTenantList(val);
      }
    }, 800);
  }
  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleClickCheckBox = (e) => {
    this.setState({
      ischeckbox: e.target.checked,
    });
  };

  handleCompanyChange(selectedValue) {
    this.state.tenantId = selectedValue;
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    this.setState({ tenantId: selectedValue });
  }

  loginInBackend = (e) => {
    // if (!this.state.sendOtpByEmail && !this.state.sendOtpByText) {
    //   this.setState({
    //     error: true,
    //   });
    //   return;
    // }
    let header = {
      email: this.state.email,
      tid: this.state.tenantId?.id,
      appclient: "W",
    };
    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        isRememberMe: this.state.rememberMe,
      },
    };

    FetchServerData.callPostService(DPTextLogin_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          store.dispatch(headerAction.setHeader(output.header));
          this.props.navigate("/dpVerifyotp", {
            state: {
              businessDomain: output?.appuser?.businessDomain,
              resendOtpByEmail: output?.appuser?.sendOtpByEmail,
              resendOtpByText: output?.appuser?.sendOtpByText,
              sendOtpByEmail: output?.appuser?.sendOtpByEmail,
              sendOtpByText: output?.appuser?.sendOtpByText,
              rememberMe: this.state.rememberMe,
              password: this.state.password,
            },
          });
        }
      })
      .catch((error) => { });
  };

  DPTextRmLoginInBackend = (header) => {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(DPTextRmLogin_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = response.data?.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          this.processLoginSuccess(output);
          if (appuser.isRememberMe) {
            localStorage.setItem("dptextRememberMe", appuser.isRememberMe);
            localStorage.setItem("dptextHeader", JSON.stringify(output.header));
          }
        }
      })
      .catch((error) => { });
  };

  processLoginSuccess(output_data) {
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
    let logoData = {
      logo: output_data.appuser?.organization?.logo
        ? output_data.appuser?.organization?.logo
        : "",
      logoFilename: output_data.appuser?.organization?.logoFilename
        ? output_data.appuser?.organization?.logoFilename
        : "",
      logoFileextension: output_data.appuser?.organization?.logoFileextension
        ? output_data.appuser?.organization?.logoFileextension
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    if (output_data.isTollfreeNumberPurchased === true) {
      store.dispatch(SelectedTabAction.setSelectedTab(0));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
      if (output_data.cmpaigningInfoError) {
      }
    }
    let header = output_data.header;
    this.loadDashboardPage(header, output_data);
  }
  async loadDashboardPage(header, output) {
    let menus = output.appuser?.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    await this.setStaticData(header);
    store.dispatch(
      ActiveMenuAction.setActiveMenu(Utils.getArrayElement(menus, 0)?.pageid)
    );
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }
  async setStaticData(header) {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(StaticDPText_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          store.dispatch(staticDataAction.setStaticData(output.data));
        } else {
        }
      }
    );
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  handleCheckboxChange = () => {
    this.setState((prevState) => ({ rememberMe: !prevState.rememberMe }));
  };

  getClientIdInBackend = (e) => {
    const postObject = {
      header: {},
    };

    FetchServerData.callPostService("/staticms/getClientId", postObject)
      .then((response) => {
        if (response.status === "SUCCESS") {
          let clientId = response.data.clientId;
          this.setState({
            clientId: clientId,
          });
        } else {
        }
      })
      .catch((error) => { });
  };

  handleSuccess = (credentialResponse) => {
    const googleToken = credentialResponse.credential; // This is the idToken
    const userObject = JSON.parse(atob(googleToken.split(".")[1]));
    if (userObject.email.endsWith(".com")) {
      this.getTenantList(userObject.email);
    }

    if (userObject) {
      this.setState({
        googleToken: googleToken,
        email: userObject.email,
        isAuthenticated: true,
      });
    } else {
    }
  };

  handleError = () => {
    console.error("Login Failed");
  };

  signInWithGoogleInBackend = (e) => {
    let header = {
      email: this.state.email,
      tid: this.state.tenantId.id,
      appclient: "W",
    };
    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        googleToken: this.state.googleToken,
        isRememberMe: this.state.rememberMe,
      },
    };

    FetchServerData.callPostService(DPTextGmailLogin_Url, postObject)
      .then((response) => {
        if (response.status === "SUCCESS") {
          let output = response.data;
          if (output.appuser.isRememberMe) {
            localStorage.setItem("dptextUserId", this.state.email);
            localStorage.setItem("dptextGoogleToken", this.state.googleToken);
            localStorage.setItem(
              "dptextSelectedOption",
              JSON.stringify(this.state.tenantId)
            );
            localStorage.setItem(
              "dptextRememberMe",
              output.appuser.isRememberMe
            );
          }
          store.dispatch(headerAction.setHeader(output.header));
          this.processLoginSuccess(output);
        } else {
        }
      })
      .catch((error) => { });
  };

  rmEmailLoginInBackend = (header) => {
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(DPTextRmGmailLogin_Url, postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = output.appuser;
          store.dispatch(headerAction.setHeader(output.header));
          if (appuser.isRememberMe) {
            localStorage.setItem("dptextRememberMe", appuser?.isRememberMe);
            localStorage.setItem("dptextGmailHeader", JSON.stringify(output.header));
          }
        }
      })
      .catch((error) => { });
  };

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <header
            id="dptextheader"
            className="fixed-top d-flex align-items-center"
          >
            <div className="container d-flex align-items-center justify-content-between">
              <div className="logo">
                <img
                  src={dpTextLogo}
                  alt=""
                  style={{ width: "auto", height: "60px" }}
                />
              </div>
              {/* <nav id="navbar" className="navbar">
                <ul>
                  <li className="active">
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignin"
                      style={{ color: "#53a5ff" }}
                    >
                      Signin
                    </a>
                  </li>
                  <li>
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignup"
                      style={{ color: "#53a5ff" }}
                    >
                      Sign Up
                    </a>
                  </li>
                </ul>
                <i className="bi bi-list mobile-nav-toggle" />
              </nav> */}
            </div>
          </header>
          {/* Register */}
          <div className="d-flex col-12 col-lg-12 col-xl-12 align-items-center authentication-bg p-sm-5 p-4">
            <div className="mx-auto" style={{ width: "420px" }}>
              <div className="signinHeding">Sign In</div>
              {this.state.pageId === "DPTextRegistration" && (
                <p>
                  Please enter your temporary password below (sent to you by
                  text message and email). You can set a permanent password
                  after you log in.
                </p>
              )}
              {!this.state.isAuthenticated ? (
                <ValidatorForm
                  ref="form"
                  id="formAuthentication"
                  className="mb-3"
                  onSubmit={this.loginInBackend.bind(this)}
                >
                  <div className="mb-3">
                    <label className="form-label" htmlFor="multiStepsEmail">
                      User ID{" "}
                      <span className="fw-normal">(email address)</span>
                    </label>
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="email"
                      name="dptextUserId"
                      value={this.state.email}
                      onChange={this.handleEmailChange.bind(this)}
                      id="multiStepsEmail"
                      className="form-control"
                      aria-label="john.doe"
                    />{" "}
                  </div>
                  {this.state.isCompany && (
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="multiStepsLastName"
                      >
                        Company name
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.tenantList}
                        value={this.state.tenantId}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.tenantId}
                        onChange={(event, value) => {
                          this.handleCompanyChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Company name"
                            name="dptextSelectedOption"
                            variant="outlined"
                            size="small"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  )}
                  <div className="mb-3 form-password-toggle">
                    <label className="form-label" htmlFor="multiStepsPass">
                      Password{" "}
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        className="form-control"
                        aria-describedby="multiStepsPass2"
                        onChange={this.handlePasswordChange.bind(this)}
                        value={this.state.password}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        id="multiStepsPass2"
                        onClick={this.handleClickShowPassword.bind(this)}
                      >
                        {this.state.showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex">
                    <div className="col-md-12 d-flex rememberMeCheckbox">
                      <FormControlLabel
                        style={{
                          width: "60%",
                          margin: "0",
                          padding: "0",
                          alignItems: "flex-start",
                        }}
                        control={
                          <Checkbox
                            variant="outlined"
                            id="rememberMe"
                            checked={this.state.rememberMe}
                            onChange={this.handleCheckboxChange.bind(this)}
                            style={{
                              background: "none",
                            }}
                          />
                        }
                        label={
                          <span
                            className="form-label fw-normal"
                            style={{
                              fontSize: "14px",
                              margin: "0 8px 0 4px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                              lineHeight: "1.2",
                            }}
                          >
                            Remember me on this device
                          </span>
                        }
                      />
                    </div>
                  </div>
                  <button
                    className="dptextSiginButton d-grid w-100"
                    type="submit"
                  >
                    Sign in
                  </button>
                </ValidatorForm>
              ) : (
                <ValidatorForm
                  ref="form"
                  id="formAuthentication"
                  className="mb-3"
                  onSubmit={this.signInWithGoogleInBackend.bind(this)}
                >
                  <div className="mb-3">
                    <label className="form-label" htmlFor="multiStepsEmail">
                      User ID (email address)
                    </label>
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="email"
                      name="dptextUserId"
                      value={this.state.email}
                      onChange={this.handleEmailChange.bind(this)}
                      id="multiStepsEmail"
                      className="form-control"
                      aria-label="john.doe"
                    />{" "}
                  </div>
                  {this.state.isCompany && (
                    <div className="mb-3">
                      <label
                        className="form-label"
                        htmlFor="multiStepsLastName"
                      >
                        Company name
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.tenantList}
                        value={this.state.tenantId}
                        getOptionLabel={(option) => option.name}
                        defaultValue={this.state.tenantId}
                        onChange={(event, value) => {
                          this.handleCompanyChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Company name"
                            name="dptextSelectedOption"
                            variant="outlined"
                            size="small"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  )}
                  <div className="row mb-2 d-flex">
                    <div className="col-md-12 d-flex">
                      <span style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          checked={this.state.rememberMe}
                          name="dptextRememberMe"
                          onChange={this.handleCheckboxChange.bind(this)}
                        />
                      </span>
                      <label className="form-label ms-1 fw-normal">
                        Remember me
                      </label>
                    </div>
                  </div>
                  <button
                    className="dptextSiginButton d-grid w-100"
                    type="submit"
                  >
                    Sign in
                  </button>
                </ValidatorForm>
              )}
              <div className="d-flex flex-row">
                <div class="col-md-12 align-self-start">
                  {this.state.pageId !== "DPTextRegistration" && (
                    <NavLink to="/dpForgotPassword">
                      <span>Forgot Password?</span>
                    </NavLink>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DPTextSignin);
